import apiClient from '../utils/apiClient';

const base = (facilityId) => `/api/facilities/${facilityId}`;

const gateSystemsService = {
  // Config
  getConfig: (facilityId) => apiClient.get(`${base(facilityId)}/gate-system/config`),
  putConfig: (facilityId, payload) =>
    apiClient.put(`${base(facilityId)}/gate-system/config`, payload),
  healthcheck: (facilityId) =>
    apiClient.post(`${base(facilityId)}/gate-system/healthcheck`),
  // Fire the gate's open relay now. Works while a provider is in trial /
  // shadow mode — opening touches no tenant's access — which is how a newly
  // wired board is bench-tested before it is trusted with the gate.
  openGate: (facilityId, note) =>
    apiClient.post(`${base(facilityId)}/gate-system/open`,
      { note: note || null }),

  // Remote opener — a relay wired in parallel with the facility's gate
  // system. A separate slot: connecting one never changes the gate provider,
  // so what tenants are sent at move-in stays exactly as it was.
  getRemoteOpener: (facilityId) =>
    apiClient.get(`${base(facilityId)}/gate-system/remote-opener`),
  // Send the key only when one was typed — blank means keep the stored key.
  saveRemoteOpener: (facilityId, { apiKey, baseUrl, latchId, allowLive }) =>
    apiClient.put(`${base(facilityId)}/gate-system/remote-opener`, {
      provider: 'nimbio',
      latch_id: latchId,
      allow_live: !!allowLive,
      ...(baseUrl !== undefined ? { base_url: baseUrl } : {}),
      ...(apiKey ? { api_key: apiKey } : {}),
    }),
  removeRemoteOpener: (facilityId) =>
    apiClient.delete(`${base(facilityId)}/gate-system/remote-opener`),
  // Reads only: is the key accepted, and is THIS board online right now?
  checkRemoteOpener: (facilityId) =>
    apiClient.post(`${base(facilityId)}/gate-system/remote-opener/check`),

  // Gate events — the Gate Activity Log feed (report side).
  // params: { from, to, customer, event_types, skip, limit }
  listEvents: (facilityId, params = {}) =>
    apiClient.get(`${base(facilityId)}/gate-system/events`, { params }),
  // CSV export — returns a Blob the caller downloads.
  exportEventsCsv: (facilityId, params = {}) =>
    apiClient.get(`${base(facilityId)}/gate-system/events`, {
      params: { ...params, format: 'csv' },
      responseType: 'blob',
    }),

  // Access records
  listAccess: (facilityId, params = {}) =>
    apiClient.get(`${base(facilityId)}/gate-access`, { params }),
  getAccess: (facilityId, recordId) =>
    apiClient.get(`${base(facilityId)}/gate-access/${recordId}`),
  createAccess: (facilityId, rentalId) =>
    apiClient.post(`${base(facilityId)}/gate-access`, { rental_id: rentalId }),
  operatorPaste: (facilityId, recordId, payload) =>
    apiClient.patch(`${base(facilityId)}/gate-access/${recordId}/operator-paste`, payload),
  revoke: (facilityId, recordId, reason) =>
    apiClient.post(`${base(facilityId)}/gate-access/${recordId}/revoke`, { reason }),
};

export default gateSystemsService;
